import './styles.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import { hydrate, setRerenderer, state } from './state';
import { App } from './actions';
import { initSheetOverlay } from './lib/sheet';
import { hydratePhotoImages } from './lib/photoUrls';
import { renderDashboard, mountDashboard } from './screens/dashboard';
import { renderExpenses } from './screens/expenses';
import { renderMapPhotos, mountMapPhotos } from './screens/mapPhotos';
import { renderReports, mountReports } from './screens/reports';
import { renderSettings } from './screens/settings';

declare global {
  interface Window {
    App: typeof App;
  }
}
window.App = App;

function renderApp(): void {
  const app = document.getElementById('app');
  if (!app || !state.ready) return;

  let body = '';
  let mount: (() => void) | undefined;
  switch (state.activeTab) {
    case 'dashboard':
      body = renderDashboard();
      mount = mountDashboard;
      break;
    case 'expenses':
      body = renderExpenses();
      break;
    case 'map':
      body = renderMapPhotos();
      mount = mountMapPhotos;
      break;
    case 'reports':
      body = renderReports();
      mount = mountReports;
      break;
    case 'settings':
      body = renderSettings();
      break;
  }
  app.innerHTML = body;
  hydratePhotoImages(app);
  mount?.();
}

async function boot(): Promise<void> {
  initSheetOverlay();
  setRerenderer(renderApp);
  await hydrate();
  renderApp();
  registerServiceWorker();
}

function registerServiceWorker(): void {
  // vite-plugin-pwa injects this virtual module at build time; during `vite dev`
  // (devOptions.enabled=false) it's a no-op, which is fine — offline support is a
  // production/installed-app concern, not a dev-server one.
  import('virtual:pwa-register')
    .then(({ registerSW }) => {
      registerSW({ immediate: true });
    })
    .catch(() => {
      /* PWA plugin not active (e.g. plain `vite dev`) — ignore. */
    });
}

boot();
